import { ApplicantDetailsROWResponse } from "@modules/application-section-row/application-details/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApplicationDetails } from "../apiEndPoints";

export const fetchApplicationDetails = createAsyncThunk<
  ApplicantDetailsROWResponse,
  number
>("details/fetchApplicationDetails", async (access_id) => {
  try {
    const response = await getApplicationDetails({
      access_id,
    }); 
    return response.data.data;
  } catch (error: any) {
    // return thunkAPI.rejectWithValue(
    //   error.response?.data || error.message || "Failed to load documents"
    // );
  }
});


